import { useState } from 'react';

import { Box, SxProps, Theme } from '@mui/material';

import { QuestionHeader, QuestionHeaderProps } from './QuestionHeader';
import { QuestionRow, QuestionRowProps } from './QuestionRow';

type QuestionViewProps = Readonly<{
  header: QuestionHeaderProps;
  /** the QuestionView will handle the expanded states */
  questions: Omit<QuestionRowProps, 'toggleExpand' | 'expanded'>[];
}>;

export const QuestionView = ({ header, questions }: QuestionViewProps) => {
  const [expandedQuestion, setExpandedQuestion] = useState<string | null>(null);

  return (
    <Box sx={containerSx}>
      <QuestionHeader
        title={header.title}
        subCategory={header.subCategory}
        description={header.description}
        tooltips={header.tooltips}
      />
      {questions.map((question) => (
        <QuestionRow
          key={question.title}
          title={question.title}
          description={question.description}
          expanded={expandedQuestion === question.title}
          toggleExpand={() =>
            setExpandedQuestion(expandedQuestion === question.title ? null : question.title)
          }
          answers={question.answers}
          onAnswerChange={(answerKey) => {
            question.onAnswerChange(answerKey);
          }}
        />
      ))}
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  borderRadius: backrs.radius['radius-xl'],
  margin: backrs.spacing['spacing-xl'],
  maxWidth: '1098px',
});
